export enum AmbassadorPopupTrigger {
  ON_FIRST_LOGIN = 'on_first_login',
  BY_STUDENT_SENIORITY = 'by_student_seniority',
  AFTER_MULTIPLE_COURSES = 'after_multiple_courses'
}
